<div
  [formGroup]="userModalFG()"
  class="flex flex-col gap-2"
>
  @if (rolesVisible()) {
    <div class="flex flex-col gap-y-2 max-w-full">
      <ng-container
        *ngTemplateOutlet="attributesLabel; context: { $implicit: 'User Role & Membership' }"
      />
      <flx-select
        [multi]="true"
        [allOptions]="roles.value()"
        [options]="filteredRoles()"
        [maxRows]="2"
        (filterChange)="rolesFilter.set($event)"
        class="flx-ds basis-full"
        optionClass="flx-ds"
        optionsDisplayMode="CHIPS_INSIDE"
        placeholder="Select user role"
        formControlName="roles"
        data-testId="roles-dropdown"
      >
        <flx-label class="flx-ds">User Role</flx-label>
        <flx-info-helper
          >Assign a role to define what this user can access when running a
          Solution.</flx-info-helper
        >
      </flx-select>
    </div>
  }

  @if (groupsVisible()) {
    <div class="flex flex-col gap-y-2 max-w-full">
      <div class="flex items-center gap-2">
        <flx-label class="flx-ds text-base font-bold"> {{ groupsLabel() }}</flx-label>
        <flx-info-helper
          >Add this user to a group to automatically inherit all roles associated with that
          group.</flx-info-helper
        >
      </div>
      <flx-select
        [multi]="true"
        [options]="groupOptions()"
        [maxRows]="2"
        (filterChange)="groupsFilter$.next($event)"
        class="flx-ds basis-full"
        optionClass="flx-ds"
        optionsDisplayMode="CHIPS_INSIDE"
        placeholder="Add user to groups"
        formControlName="groups"
        emptyMessage="No groups found"
        data-testId="groups-dropdown"
      >
      </flx-select>
    </div>
  }

  @if (attributesVisible()) {
    <div class="flex items-center gap-2">
      @if (canEdit() || attributesFA.controls.length) {
        <ng-container
          *ngTemplateOutlet="
            attributesLabel;
            context: {
              $implicit: 'Runtime Attributes',
              infoTooltip:
                'Store additional user data as custom key-value pairs for use within Solutions.',
            }
          "
        />
      }
      @if (canEdit() && !attributesDisabled()) {
        <button
          [disabled]="attributesFA.invalid"
          (click)="addAttribute()"
          class="flx-ds ml-auto"
          data-testId="add-attribute-button"
          flxButton
          type="button"
          variant="text"
        >
          Add Attribute
        </button>
      }
    </div>
    @if (attributesFA.length) {
      <div
        #attributesSection
        class="attributes-section text-sm"
        formArrayName="attributes"
        data-testId="runtime-attributes-section"
      >
        @for (attributeControl of attributesFA.controls; track attributeControl) {
          @let keyFC = attributeControl.get('key');

          <ng-container [formGroupName]="$index">
            <flx-input class="flx-ds">
              <input
                class="w-2/3"
                flxInput
                flxAutofocus
                formControlName="key"
                placeholder="Enter attribute name"
                data-testId="attribute-key-input"
              />
              @if (enableErrorValidation() && keyFC.errors) {
                <flx-error>
                  @if (keyFC.errors.required) {
                    Key is required
                  } @else if (keyFC.errors.pattern) {
                    Key must not contain special characters
                  } @else {
                    Duplicate keys are not allowed
                  }
                </flx-error>
              }
            </flx-input>

            <div>
              <p-autoComplete
                [multiple]="true"
                [typeahead]="false"
                [addOnBlur]="true"
                [unique]="true"
                [separator]="','"
                [invalid]="enableErrorValidation() && attributeControl.invalid"
                class="flx-prime-chips w-full"
                formControlName="values"
                placeholder="Enter attribute value"
                data-testId="attribute-value-input"
              >
                <ng-template pTemplate="removetokenicon">
                  <flx-icon name="clearCircle" />
                </ng-template>
              </p-autoComplete>
              @if (enableErrorValidation() && attributeControl.get('values').errors?.required) {
                <flx-error> At least one value is required.</flx-error>
              }
            </div>

            <button
              [disabled]="!canEdit() || attributesDisabled()"
              (click)="deleteAttribute($index)"
              class="flx-ds secondary h-fit"
              variant="ghost"
              icon="center"
              flxButton
              data-testId="delete-attribute-button"
            >
              <i
                class="ph ph-trash-simple"
                flxIcon
              ></i>
            </button>
          </ng-container>
        }
      </div>
    }
  }
</div>

<ng-template
  #attributesLabel
  let-label
  let-infoTooltip="infoTooltip"
>
  <flx-label class="flx-ds text-base font-semibold">{{ label }}</flx-label>
  @if (infoTooltip) {
    <flx-info-helper>{{ infoTooltip }}</flx-info-helper>
  }
</ng-template>
